import { useQuery } from '@tanstack/react-query';

import { Button } from '@nesso/ui/primitives/button';
import { Card } from '@nesso/ui/primitives/card';

import { emailVerificationStatusOptions } from '@/entities/user';
import { SUPPORT_EMAIL } from '@/shared/constants/support';
import { Page } from '@/shared/ui/layout/page';
import { NavigationBar } from '@/shared/ui/navigation/navigation-bar';

import { useResendVerificationLink } from '../model/use-resend-verification-link';

export function EmailUnverifiedPage() {
    const { isResending, resendLink } = useResendVerificationLink();
    const { data: emailStatus } = useQuery(emailVerificationStatusOptions());

    return (
        <Page>
            {/* Logo-only: every in-app destination is gated until the email is verified. */}
            <NavigationBar disableLogoNavigation />
            <div className="flex flex-1 items-center justify-center overflow-y-auto px-4 py-6">
                <Card className="w-full max-w-162.5 px-6 py-8 sm:px-20 sm:py-14">
                    <h1 className="text-foreground text-4xl font-bold">
                        Verify your email to keep your account safe
                    </h1>
                    {/* Deliberately not "we sent you a link": the send is asynchronous, so this
                        screen can be reached before it lands. */}
                    <p className="text-muted-foreground text-base">
                        Check{' '}
                        {emailStatus?.email ? (
                            <span className="font-bold">{emailStatus.email}</span>
                        ) : (
                            'your inbox'
                        )}{' '}
                        for your verification link. If you don&rsquo;t receive it, message{' '}
                        {SUPPORT_EMAIL}.
                    </p>
                    <Button
                        size="lg"
                        className="w-full"
                        onClick={resendLink}
                        disabled={isResending}
                    >
                        {isResending ? 'Sending…' : 'Resend Verification Link'}
                    </Button>
                </Card>
            </div>
        </Page>
    );
}
